import { defineAction } from '~/prix'
import residenceFetchAction from './residenceFetch.action.json' with { type: 'json' }
import { residenceObject } from '../residenceObject'
import { citizenObject } from '../../citizen/citizenObject'
import { z } from 'zod'
import { residenceImageObject } from '../imageList/residenceImageList.definition'
import { communityObject } from '~/packages/geo/community/communityObject'
import { inventoryObject } from '~/packages/publicSafety/inventory/inventoryObject'
import { alertObject } from '~/packages/publicSafety/alert/alertObject'
import { ruralPropertyObject } from '~/packages/rural/ruralProperty/ruralPropertyObject'
import { ruralPropertyActivityObject } from '~/packages/rural/ruralPropertyActivity/ruralPropertyActivityObject'
import { animalProductionObject } from '~/packages/rural/animalProduction/animalProductionObject'
import { propertyImprovementsObject } from '~/packages/rural/propertyImprovements/propertyImprovementsObject'

const residenceFetchDefinition = defineAction({
  ...residenceFetchAction,

  input: z.object({ id: z.string().uuid() }),
  output: residenceObject.extend({
    images: z.array(residenceImageObject).nullish(),
    geo: z.object({}).nullish(),
    citizens: z
      .array(
        citizenObject.extend({
          cns: z.string().nullish(),
          clientId: z.number().nullish(),
          originalId: z.string().nullish(),
          dataSourceId: z.number().nullish(),
        }),
      )
      .nullish(),
    clientId: z.number().nullish(),
    originalId: z.string().nullish(),
    dataSourceId: z.number().nullish(),
    community: communityObject.nullish(),
    inventory: z.array(inventoryObject).nullish(),
    alerts: z.array(alertObject).nullish(),
    // Inclui as listas filhas no rural_property (atividades, produção animal, benfeitorias)
    ruralProperty: ruralPropertyObject
      .extend({
        activities: z.array(ruralPropertyActivityObject).nullish(),
        animalProductions: z.array(animalProductionObject).nullish(),
        improvements: z.array(propertyImprovementsObject).nullish(),
      })
      .nullish(),
  }),
})

export default residenceFetchDefinition
